export default "__VITE_ASSET__DtrfBVuT__"